import API from './api';

const basePath = `${process.env.REACT_APP_API_HUB}/operacao/v1/operacoes`;

export const listarTitulosEmAbertoHojeBL = params => API.post(`${basePath}/em-aberto-hoje-bl`, params);

export const indeferirTitulosLote = params => API.post(`${basePath}/indeferimento-lote`, params);

export const listarEmpresasIndeferimentoLote = params =>
  API.get(`${basePath}/indeferimento-lote/filtros/empresas`, { params });
